// storeFcmToken.js
import { getToken } from "firebase/messaging";
import { messaging } from "./firebase-config";
import axios from "axios";
import { API_URL } from "api/config";

export const storeFcmToken = async () => {
  
  try {
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      const token = await getToken(messaging, {
        vapidKey: "BCkLspZOGz37ze9YlJ6d9gP1PplUFIast0l40pt5HYsYNz3eBL_I3sIoluXMvBnHzMfIRYiYrblfyPp6fW9Bjzc",
        serviceWorkerRegistration: registration,
  
      });
  
      if (token) {
        console.log('FCM Token:', token);
        return token
   
      } else {
        console.log("No registration token available.");
      }
    }

 
  } catch (error) {
    console.error("Error getting FCM token", error);
  }
};
